import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getSFGBoxRetrivalHistoryID } from './services';
import dayjs from 'dayjs';

const ViewSFGHistory =()=>{
    const[retrievData, setRetrieveData] = React.useState([])
    const param = useParams()

    useEffect(()=>{
        handleRetrieveBoxData()
    },[param.id])

    const handleRetrieveBoxData = async()=>{
        try{
            const resp = await getSFGBoxRetrivalHistoryID(param.id)
            if(resp.status === 200){
                setRetrieveData(resp.data.payload)
            }
        }
        catch(err){
            console.log(err)
        }
    }
    return(
        <>
        <div className="dashboard-wrapper page-wraper">
        <div className="page-header">
        <Link to="/sfg-inventory" className="page-back-btn">
          <ArrowBackIcon />
          <span>SFG Box Retrieve History</span>
        </Link>
        </div>
        <div className="pt-3 table-responsive">
        <TableContainer component={Paper}>
          <Table
            aria-label="Dipping parameter"
            className="dipping-params sfg-score-table"
          >
            <TableHead>
              <TableRow>
                <TableCell>Label No.</TableCell>
                <TableCell>Date and Time</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Class</TableCell>
                <TableCell>Size</TableCell>
                <TableCell>Length</TableCell>
                <TableCell>Cuff</TableCell>
                <TableCell>Lot No</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Box No.</TableCell>
                <TableCell>Rack Id</TableCell>
                <TableCell>User</TableCell>
               
              </TableRow>
             
            </TableHead>
            <TableBody>
              {/* Dynamically render table rows from inventoryData */}
              {retrievData && retrievData.length > 0 ? (
                retrievData.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.box_no}</TableCell>
                    <TableCell>
                      {item.created_at
                        ? dayjs(item.created_at).format("YYYY-MM-DD HH:mm:ss")
                        : ""}
                    </TableCell>
                    <TableCell>{item.gloves_type}</TableCell>
                    <TableCell>{item.class_name}</TableCell>
                    <TableCell>{item.size_name}</TableCell>
                    <TableCell>{item.length}</TableCell>
                    <TableCell>{item.cuff}</TableCell>
                    <TableCell>{item.lot_no}</TableCell>
                    <TableCell>{item.quantity}</TableCell>
                    <TableCell>{item.sfg_label}</TableCell>
                    <TableCell>{item.rack_id}</TableCell>
                    <TableCell>{item.created_by}</TableCell>
               
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={12} align="center">
                    No data found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
            </div></>
    )
}

export default ViewSFGHistory;